module.exports = __webpack_public_path__ + "8a6f511c5d92ba7a258cd85240d33623.svg";